import { render } from "./AddMandaturePage.vue?vue&type=template&id=3a568856&ts=true"
import script from "./AddMandaturePage.vue?vue&type=script&lang=ts"
export * from "./AddMandaturePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__